module.exports = __webpack_public_path__ + "static/WORLD1-430b04b813844b74bc51e3288d93a1f3.jpg";